// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1u-xa","col":"styles_col__1ApKJ"};